<h1 mat-dialog-title class="dialog-title">
    <mat-icon>info</mat-icon>
    <span>Detalhes da Notificação</span>
</h1>

<div mat-dialog-content class="dialog-content">
    
    @if(data.datetimeDelecao) {
        <div class="deleted-alert-container">
            <div class="alert-header">
                <mat-icon>warning</mat-icon>
                <span>Notificação Excluída</span>
            </div>
            <div class="alert-body">
                <p><strong>Deletado por:</strong> {{ data.nomeUsuarioDelecao }}</p>
                <p><strong>Data da Exclusão:</strong> {{ data.datetimeDelecao | date:'dd/MM/yyyy HH:mm' }}</p>
                <p><strong>Motivo:</strong> {{ data.motivoDelecao }}</p>
            </div>
        </div>
    }

    <div class="detail-group">
        <label>Título:</label>
        <p class="highlight-text">{{ data.tituloMensagem }}</p>
    </div>

    <div class="row-info">
        <div class="detail-item">
            <label>Enviado por:</label>
            <span>{{ data.nomeRemetente }}</span>
        </div>
        <div class="detail-item">
            <label>Data de Envio:</label>
            <span>{{ data.datetimeInclusao | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
    </div>

    <div class="row-info stats-container">
        <div class="stat-item">
            <label>Destinatários:</label>
            <span class="stat-value">{{ data.quantidadeDestinatarios }}</span>
        </div>
        <div class="stat-item">
            <label>Lidos:</label>
            <span class="stat-value">{{ data.quantidadeLidos }}</span>
        </div>
    </div>

    <div class="detail-group">
        <label>Mensagem:</label>
        <div class="message-box" [innerHtml]="data.conteudoMensagem">
        </div>
    </div>

</div>

<div mat-dialog-actions align="end">
    <button mat-flat-button class="btn-secundary" (click)="fechar()">Fechar</button>
</div>